import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Wordmark } from "./Logo";
import { NAV_LINKS, CONTACT } from "../lib/content";
import ObfuscatedEmail from "./ObfuscatedEmail";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative bg-navy grain text-white overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 pt-24 pb-12">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Let&apos;s talk</p>
            <Link to="/contact" className="group inline-flex items-start gap-4">
              <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl font-medium leading-[0.95] transition-colors duration-300 group-hover:text-gold">
                Start your <br /> enquiry
              </h2>
              <ArrowUpRight className="mt-3 text-gold transition-transform duration-300 group-hover:translate-x-2 group-hover:-translate-y-1" size={44} />
            </Link>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-white/40 mb-6">Quick Links</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-white/70 hover:text-gold transition-colors duration-300"
                    data-testid={`footer-nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-white/40 mb-6">Contact</p>
            <ul className="space-y-4 text-white/70">
              <li>
                <span className="block text-xs text-white/40 mb-1">Email</span>
                <ObfuscatedEmail user="intolaw" domain="praxio.co.za" className="hover:text-gold transition-colors" data-testid="footer-email" />
              </li>
              <li>
                <span className="block text-xs text-white/40 mb-1">WhatsApp</span>
                <a
                  href={`https://wa.me/${CONTACT.whatsappNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gold transition-colors"
                  data-testid="footer-whatsapp"
                >
                  {CONTACT.whatsappDisplay}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 0.06 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="pointer-events-none select-none mt-16 -mb-6"
          aria-hidden="true"
        >
          <Wordmark variant="light" className="text-[18vw] leading-none" />
        </motion.div>

        <div className="mt-8 flex flex-col gap-4 border-t border-white/10 pt-8 text-sm text-white/50 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="text-white/70 font-medium">IntoLaw — A Division of Praxio (Pty) Ltd</p>
            <p>Accessible Legal Solutions for Businesses and Individuals</p>
          </div>
          <p>© {year} IntoLaw, a Division of Praxio (Pty) Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
